import { AnalyticsDomain } from '@api/models/enums/AnalyticsDomain';
import { AnalyticsDomainConfig } from './analyticsDomainConfig';
import { visitationConfig } from './domains/visitation/visitationConfig';

export const DOMAIN_CONFIG_MAP: Record<AnalyticsDomain, AnalyticsDomainConfig> = {
  // @ts-expect-error contravariant form values - each config is typed internally
  [AnalyticsDomain.Visitations]: visitationConfig,
};

export const ANALYTICS_DOMAINS: AnalyticsDomainConfig[] = Object.values(DOMAIN_CONFIG_MAP);

export const findDomainByKey = (key: string | undefined): AnalyticsDomainConfig | undefined => {
  if (!key) return undefined;
  return ANALYTICS_DOMAINS.find((d) => d.key === key);
};
